<select class="form-control" (change)="handleLanguageSelectionChange($event)">
  <option
    *ngFor="let lang of currentAppLangs"
    [selected]="lang.isO2 == defaultLangIso2"
    value="{{ lang.isO2 }}"
  >
    {{ lang.displayName }}
  </option>
</select>
